import { Action } from "..";

import { LasServiceBase } from "../../types/lasServiceBase";
import { LAS_SERVICE_CHANGE } from "../actions/lasService";

export interface LasServiceState {
  lasService: LasServiceBase | null;
}

const initialState: LasServiceState = {
  lasService: null,
};

const lasServiceReducer = (
  state: LasServiceState = initialState,
  action: Action
): LasServiceState => {
  switch (action.type) {
    case LAS_SERVICE_CHANGE:
      return { ...state, lasService: action.payload };
    default:
      return state;
  }
};

export default lasServiceReducer;
